var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitMEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73505 0C9.57345 0 9.41167 0.0615591 9.28851 0.185033L8.21041 1.26316L10.7367 3.78947L11.8148 2.71135C12.0617 2.4644 12.0617 2.06457 11.8148 1.81826L10.1816 0.185033C10.0581 0.0615591 9.89666 0 9.73505 0ZM7.26305 2.21053L0 9.47368V12H2.52628L9.78933 4.73684L7.26305 2.21053Z",
    fill: "#A4A4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitMEdit);
export default __webpack_public_path__ + "static/media/limit_m_edit.c01a8bfd3aeaa12eb0fbe5386ca05b91.svg";
export { ForwardRef as ReactComponent };